import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnableModulesService {
  private confirmationPage: boolean = false;

  constructor() { }

  getConfirmationPage(): boolean{
    return this.confirmationPage;
  }

  setConfirmationPage(value: boolean): void {
    this.confirmationPage = value;
  }

}
